<template>
  <div class="custom-rating">
    <Rating v-model="integerPart" :stars="stars" :cancel="false" readonly />
  </div>
</template>

<script>
import Rating from 'primevue/rating'

export default {
  name: 'CustomRating',
  components: {
    Rating,
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
    stars: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    integerPart() {
      return Math.floor(this.value)
    },
    fractionalPart() {
      return this.value - this.integerPart
    },
  },
}
</script>

<style>
.p-rating .p-rating-icon.pi-star-fill {
  color: #fbbc02;
}
.p-rating .p-rating-icon {
  color: #dadce0;
}
</style>
